/**
 * 获取各种参数
 * @type {[type]}
 */
import store from '../store';
import storage from '../helper/storage';
import querySysInfo from './querySysInfo';



function queryLoginInfo() {
    let loginInfo = JSON.parse(storage.get('loginInfo') || '{}');
    if (loginInfo) {
        store.commit('updateSignIn', loginInfo);
    }
}

function queryOpenId() {
    let openId = storage.get('openId') || '';
    if (openId) {
        store.commit('updateOpenId', openId);
    }
}

function queryCode() {
    let companyCode = storage.get('companyCode') || '';
    if (companyCode) {
        store.commit('updateCode', companyCode);
    }
}

function queryCart() {
    let cart = JSON.parse(storage.get('cart') || '[]');
    if (cart) {
        store.commit('updateCart', cart);
    }
}

/**
 * 判断以 URL 中的code为准
 *  不一致  => 清除
 *  一致  => 取本地缓存数据
 */
function clearLoginInfo() {
    let code = storage.get('companyCode');
    // 设置 /order/ 为白名单
    if (window.location.pathname.indexOf('/order/') == -1 && window.location.pathname.indexOf('/lpk') == -1 && window.location.href.indexOf(code) == -1) {
        storage.remove('companyCode');
        storage.remove('loginInfo');
        storage.remove('openId');
        storage.remove('cart');
    } else {
        queryLoginInfo();
        queryOpenId();
        queryCode();
        queryCart();
    }
}


clearLoginInfo();


querySysInfo();
// isWeixin();

// export {
//     querySysInfo
// };
